/* eslint-disable no-console */
import type { LoggerService } from '../LoggerService'

type BridgeBoundaryDetails = {
  isChunkError?: boolean
  error?: unknown
  info?: { componentStack?: string }
}

/** Captures errors swallowed by @inno-tools/container-bridge's boundary. */
export function mountConsoleErrorInterceptor(
  logger: LoggerService
): () => void {
  const original = console.error
  const wrapped = (...args: unknown[]) => {
    if (args[0] === 'DETECTED AN ERROR') {
      const details = args[2] as BridgeBoundaryDetails | undefined
      logger.exception(
        'react.container_bridge_error_boundary',
        details?.error ?? args[0],
        {
          debugName: typeof args[1] === 'string' ? args[1] : undefined,
          isChunkError: details?.isChunkError,
          componentStack: details?.info?.componentStack
        },
        { category: 'runtime' }
      )
    }
    original.apply(console, args)
  }
  console.error = wrapped
  return () => {
    if (console.error === wrapped) console.error = original
  }
}
